import React from "react"
import { connect } from "react-redux"
import QueryString from "query-string"
import _ from "lodash"
import { Pagination, Tabs } from "antd"
import { Button } from "reactstrap"
import ErrorBoundComponent from "../../components/ErrorBoundComponent"
import UpsertGameForm from "./upsertWebGames"
import Auxiliary from "../../util/Auxiliary"
import "../Comment/browseComment.style.css"
import {
  getEntities,
  resetState,
  upsertWebGame,
  removeGame,
} from "../../appRedux/slices/zeroSearch"
import { markTrending } from "appRedux/slices/trending"
import GameCard from "./gameCard"
import UpsertTrendingPayload from "../CommonTrending/trendingUpsert"
import Chips from "components/CommonFilter/chips"
import {
  manageWebGamesFilters,
  NO_PERMISSION_MESSAGE,
} from "constants/uiConstants"

import toastr from "toastr"

const FILTER_KEYS = [
  {
    key_name: "name",
    display_name: "Name",
  },
  {
    key_name: "webGameId",
    display_name: "Web-Game Id",
  },
]

class ManageWebGames extends ErrorBoundComponent {
  state = {
    showModal: false,
    showTrendingForm: false,
    gameId: "",
    filters: {
      pageSize:
        this.props.queryParams && this.props.queryParams["pageSize"]
          ? this.props.queryParams["pageSize"]
          : 10,
      currentPage:
        this.props.queryParams && this.props.queryParams["currentPage"]
          ? this.props.queryParams["currentPage"]
          : 1,
      type:
        this.props.queryParams && this.props.queryParams["type"]
          ? this.props.queryParams["type"]
          : "GAME",
      name:
        this.props.queryParams && this.props.queryParams["name"]
          ? this.props.queryParams["name"]
          : "",
      webGameId:
        this.props.queryParams && this.props.queryParams["webGameId"]
          ? this.props.queryParams["webGameId"]
          : "",
    },
  }

  componentDidMount() {
    if (!this.props.common.error) {
      let filters = _.clone(this.state.filters)
      this.props.dispatch(getEntities({ filters: _.deepClean(filters) }))
      this.setState({ filters })
      window.addEventListener("keydown", this._keyDownHandler)
    }
  }

  componentDidUpdate() {
    if (this.props.refetch) {
      let filters = _.clone(this.state.filters)
      this.props.dispatch(getEntities({ filters: _.deepClean(filters) }))
    }
  }

  componentWillUnmount() {
    this.props.dispatch(resetState())
    window.removeEventListener("keydown", this._keyDownHandler)
  }

  _keyDownHandler = ({ key }) => {
    if (key === "Enter" && this.state.showFilters === true) {
      return this._closeFilters()
    }
    if (key === "Escape" && this.state.showFilters === true) {
      this.setState({
        showFilters: false,
      })
    }
  }

  _handleFilterChange = (value, type) => {
    const newFilters = _.cloneDeep(this.state.filters)
    newFilters[type] = value
    this.setState({ filters: newFilters })
  }

  _searchEntity = () => {
    let { filters } = this.state
    if (filters && filters.pageSize) {
      delete filters.currentPage
    }
    this.props.history.push(
      `/webGames/manage?${QueryString.stringify(
        _.deepClean(this.state.filters)
      )}`
    )
    this.props.dispatch(getEntities({ filters: _.deepClean(filters) }))
  }

  _onPageChange = value => {
    let newFilters = _.cloneDeep(this.state.filters)
    newFilters["currentPage"] = value
    this.setState({ filters: newFilters }, () => {
      this.props.history.push(
        `/webGames/manage?${QueryString.stringify(
          _.deepClean(this.state.filters)
        )}`
      ),
        this.props.dispatch(getEntities({ filters: _.deepClean(newFilters) }))
    })
  }

  _onSubmit = async payload => {
    let response
    response = await this.props.dispatch(
      upsertWebGame({
        data: payload,
        action: this.state.action,
        gameId:
          this.state.entityData && this.state.entityData.game_uuid
            ? this.state.entityData.game_uuid
            : "",
      })
    )

    this.setState({ showModal: false, entityData: null })
  }

  _onTrendingSubmit = async payload => {
    let response
    response = await this.props.dispatch(
      markTrending({
        data: payload,
        type: "game",
        entityId: this.state.gameId ? this.state.gameId : "",
      })
    )

    this.setState({ showTrendingForm: false, gameData: null })
  }

  _modal = () => {
    return (
      <div className="view_container">
        <UpsertGameForm
          pageId={this.state.currentPageId}
          type={
            this.props.queryParams && this.props.queryParams.type
              ? this.props.queryParams.type
              : "GAME"
          }
          onSubmit={this._onSubmit}
          data={this.state.entityData}
          action={this.state.action}
          onCancel={() => this.setState({ showModal: false })}
        />
      </div>
    )
  }

  _trendingForm = () => {
    return (
      <div className="view_container">
        <UpsertTrendingPayload
          pageId={this.state.currentPageId}
          type={
            this.props.queryParams && this.props.queryParams.type
              ? this.props.queryParams.type
              : "GAME"
          }
          onSubmit={this._onTrendingSubmit}
          data={
            this.state.gameData && this.state.gameData.trending_meta_cms
              ? this.state.gameData.trending_meta_cms
              : ""
          }
          action={
            this.state.gameData &&
            !_.isEmpty(this.state.gameData.trending_meta_cms)
              ? "update"
              : "create"
          }
          onCancel={() =>
            this.setState({ showTrendingForm: false, gameId: "" })
          }
        />
      </div>
    )
  }

  _onEdit = entityData => {
    this.setState({ entityData, showModal: true, action: "update" })
  }

  _onDelete = async gameId => {
    await this.props.dispatch(removeGame(gameId))
  }

  _getTitle = () => {
    const type = this.props.queryParams.type
    const typeToLowerCase = type.replace(/_|-|\./g, " ").toLowerCase()
    return (
      <h4>
        {typeToLowerCase.charAt(0).toUpperCase() + typeToLowerCase.slice(1)}
      </h4>
    )
  }

  _handleFilterChange = (value, type) => {
    const newFilters = _.cloneDeep(this.state.filters)
    newFilters[type] = value

    this.setState({
      filters: newFilters,
    })
  }

  _searchCollection = () => {
    let { filters } = this.state
    if (filters && filters.pageSize) {
      delete filters.currentPage
    }
    this.props.history.push(
      `/webGames/manage?${QueryString.stringify(
        _.deepClean(this.state.filters)
      )}`
    ),
      this.props.dispatch(getEntities({ filters: _.deepClean(filters) }))
  }

  _closeFilters = () => {
    this._searchCollection()
    this.setState({
      showFilters: false,
    })
  }

  _toggleFilters = () => {
    this.setState({
      showFilters: !this.state.showFilters,
    })
  }

  _removeFilter = filter => {
    const newFilters = {
      ...this.state.filters,
      [filter]: manageWebGamesFilters[filter].defaultValue,
    }

    this.setState(
      {
        filters: newFilters,
      },
      () => {
        this.props.history.push(
          `/webGames/manage?${QueryString.stringify(
            _.deepClean(this.state.filters)
          )}`
        )
        this.props.dispatch(
          getEntities({ filters: _.deepClean(this.state.filters) })
        )
      }
    )
  }

  _onTrendingClick = gameData => {
    this.setState({
      showTrendingForm: true,
      action: "create",
      gameId: gameData.game_uuid,
      gameData: gameData,
    })
  }

  _buttons = () => {
    return (
      <div className="d-flex justify-content-end my-2">
        <div className="d-flex">
          <Button
            color="primary"
            className="d-flex mx-2"
            onClick={() => {
              if (
                !this.props.currentUser?.permissions?.includes("EDIT_WEB_GAMES")
              ) {
                toastr.error(NO_PERMISSION_MESSAGE)
                return
              }
              this.setState({ showModal: true, action: "create" })
            }}
          >
            <i className="fa fa-plus mx-1 my-1" />
            Add
          </Button>
        </div>
      </div>
    )
  }

  render() {
    return (
      <React.Fragment>
        <Auxiliary
          loading={this.props.loading}
          error={_.get(this.props, "common.error")}
        >
          {!this.state.showModal && !this.state.showTrendingForm && (
            <React.Fragment>
              <Chips
                showFilters={this.state.showFilters}
                filters={this.state.filters}
                search={this._closeFilters}
                removeFilter={this._removeFilter}
                handleFilterChange={this._handleFilterChange}
                type="manage_web_games"
                toggleFilters={this._toggleFilters}
                filterKeys={FILTER_KEYS}
              />
              {this._buttons()}
              <div className="discovery-card-container">
                {this.props.entityList &&
                  this.props.entityList.map((entity, i) => {
                    return (
                      <GameCard
                        data={entity}
                        locationList={this.props.locationList}
                        onEditClick={this._onEdit}
                        hideDelete={false}
                        onDeleteClick={this._onDelete}
                        pageSource="manageEntity"
                        onTrendingClick={this._onTrendingClick}
                        currentUser={this.props.currentUser}
                        location={this.props.location}
                      />
                    )
                  })}
              </div>
              {this.props.entityList && this.props.entityList.length > 0 && (
                <div className="d-flex justify-content-end">
                  <Pagination
                    style={{
                      marginTop: "1rem",
                      marginBottom: "1rem",
                    }}
                    onChange={this._onPageChange}
                    defaultCurrent={this.state.filters.currentPage}
                    total={this.props.total < 10000 ? this.props.total : 10000}
                    pageSize={this.state.filters.pageSize}
                    showSizeChanger={false}
                  />
                </div>
              )}
            </React.Fragment>
          )}
        </Auxiliary>
        {this.state.showModal && this._modal()}
        {this.state.showTrendingForm && this._trendingForm()}
      </React.Fragment>
    )
  }
}

function mapStateToProps(store, ownProps) {
  return {
    queryParams: _.get(ownProps, "location.search")
      ? QueryString.parseUrl(_.get(ownProps, "location.search")).query
      : undefined,
    total: _.get(store, "zeroSearch.total"),
    common: _.get(store, "common"),
    isMobile: _.get(store, "common.isMobile"),
    loading: _.get(store, "zeroSearch.loading"),
    entityList: _.get(store, "zeroSearch.entities"),
    refetch: _.get(store, "zeroSearch.refetchData"),
    currentUser: _.get(store, "currentUser.currentUser.data"),
  }
}

export default connect(mapStateToProps)(ManageWebGames)
